(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('ValuationApiClient', ValuationApiClient);

    ValuationApiClient.$inject = ['$resource'];

    function ValuationApiClient ($resource) {
        var resourceUrl =  'api/valuation-api-clients/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
